import React from "react";
import { SxStyleProp } from "theme-ui";
import { FilterIcon } from "../icons";
import Flex from "../Flex/Flex";
import Text from "../Text/Text";
import Button from "../Button/Button";
import Input from "../Input/Input";

interface Props extends React.HTMLAttributes<HTMLInputElement> {
  sxWrapper?: SxStyleProp;
  placeholder?: string;
  defaultValue?: string;
  value?: string | number;
  onChange?: (event: React.FormEvent<HTMLInputElement>, value?: any) => void;
  onClear?: () => void;
  icon?: React.ReactElement;
}

const SearchInput: React.FunctionComponent<Props> = ({
  sxWrapper,
  placeholder,
  defaultValue = "",
  onChange,
  onClear,
  icon = <FilterIcon color="primary" size="20px" />,
  ...restProps
}) => {
  const [internalValue, setInternalValue] = React.useState(defaultValue);

  const handleChange = (event: React.FormEvent<HTMLInputElement>) => {
    setInternalValue(event.currentTarget.value);
    if (onChange) {
      onChange(event, event.currentTarget.value);
    }
  };

  return (
    <Flex
      align="center"
      sx={{ flex: 1, position: "relative", ...(sxWrapper as any) }}
    >
      <Input
        placeholder={placeholder}
        value={internalValue}
        onChange={handleChange}
        {...restProps}
      />
      {!!internalValue && (
        <Text
          as="button"
          fontSize={0}
          sx={{
            position: "absolute",
            top: 0,
            right: 8,
            height: "100%",
            display: "flex",
            alignItems: "center",
            color: "primary",
            cursor: "pointer",
            appearance: "none",
            border: 0,
            bg: "transparent",
          }}
          onClick={() => {
            setInternalValue("");
            if (onClear) {
              onClear();
            }
          }}
        >
          Clear
        </Text>
      )}
      <Button
        sx={{
          position: "absolute",
          right: 0,
          height: "100%",
          px: 2,
          py: 1,
          color: "border",
          bg: "white",
          border: "1px solid",
          borderRadius: "0 0.25rem 0.25rem 0",
        }}
      >
        {icon}
      </Button>
    </Flex>
  );
};

export default SearchInput;
